import { render, staticRenderFns } from "./RoomMultipleRegister.vue?vue&type=template&id=70baa322&scoped=true&lang=pug"
import script from "./RoomMultipleRegister.vue?vue&type=script&lang=ts"
export * from "./RoomMultipleRegister.vue?vue&type=script&lang=ts"
import style0 from "./RoomMultipleRegister.vue?vue&type=style&index=0&id=70baa322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70baa322",
  null
  
)

export default component.exports